// Library imports
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

// Meridian imports
import Row from "@amzn/meridian/row";
import Select, { SelectOption } from "@amzn/meridian/select";
import Text from "@amzn/meridian/text";

// Local imports
import { fetchBuildingCodes } from "features/yard360/store/buildingCodes/actions";
import { saveAuthInfo } from "features/yard360/store/authInfo/actions";
import { keys } from "i18n/keys";
import { AMAZON_BUILDING_CODE } from "app/app-constants";

export default function BuildingCodeSelector() {
  const [selectedBuildingCode, setSelectedBuildingCode] = useState();
  const [buildingCodeSearchQuery, setBuildingCodeSearchQuery] = useState();

  const activeBuildingCode = useSelector((state) => state.authInfo.activeBuildingCode);
  const buildingCodes = useSelector((state) => state.buildingCodeData.buildingCodes);

  const dispatch = useDispatch();

  const { t } = useTranslation();

  /**
   * Fetch all available buildingCodes when activeBuildingCode is Amazon
   */
  useEffect(() => {
    if (activeBuildingCode === AMAZON_BUILDING_CODE) {
      dispatch(fetchBuildingCodes());
    }
  }, [activeBuildingCode]);

  /**
   * Save selectedBuildingCode
   */
  useEffect(() => {
    if (selectedBuildingCode) {
      dispatch(saveAuthInfo({ selectedBuildingCode }));
    }
  }, [selectedBuildingCode]);

  /**
   * Filter out buildingCodes by buildingCodeSearchQuery
   */
  const matchedBuildingCodes =
    buildingCodes?.filter(
      (buildingCode) =>
        !buildingCodeSearchQuery || new RegExp(buildingCodeSearchQuery, "i").test(buildingCode)
    ) || [];

  return (
    <Select
      data-testid="buildingCodeSelector"
      disabled={activeBuildingCode !== AMAZON_BUILDING_CODE || !buildingCodes}
      searchQuery={buildingCodeSearchQuery}
      value={selectedBuildingCode}
      onSearch={setBuildingCodeSearchQuery}
      onChange={setSelectedBuildingCode}
      placeholder={t(keys.SELECT_ACCOUNT)}
      width={300}
      popoverMaxHeight={500}
    >
      {matchedBuildingCodes.map((buildingCode) => (
        <SelectOption
          key={buildingCode}
          value={buildingCode}
          label={buildingCode}
          data-testid="buildingCodeOption"
        />
      ))}
      {!matchedBuildingCodes.length && (
        <Row alignmentHorizontal="center" spacingInset="600" data-testid="buildingCodeNoResults">
          <Text>{t(keys.NO_RESULTS)}</Text>
        </Row>
      )}
    </Select>
  );
}
